import { render, staticRenderFns } from "./StockReductionPrintDetails_Total.vue?vue&type=template&id=025f8a90&"
import script from "./StockReductionPrintDetails_Total.vue?vue&type=script&lang=js&"
export * from "./StockReductionPrintDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports